import React from 'react';
import { observer } from 'mobx-react';

import {
  Image,
  Amount,
  Container,
  PurchaseInfo,
  InnerContainer,
  Price,
  TicketCode,
  Heading,
  Divider,
  Name,
} from './styles/_detailsContainer';

import { colors } from 'app/variables';

import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import { localeFormattedPrice } from 'common/utils';
import { useFacility } from 'app/facility';

const DetailsContainer = observer(() => {
  const facility = useFacility();
  const { activeObject, eventDate, eventTime } = view;
  const { price, currency, image, type, name } = activeObject;
  const { formValues, step, CONFIRMATION } = form;
  const isFree = !Number(price);
  const refNum = formValues.get('ref_num');

  return (
    <Container
      style={{
        paddingTop: !image ? '0.5rem' : '0',
        borderColor:
          step === CONFIRMATION ? colors.pacificBlue : colors.gallery,
      }}
      role="region"
      aria-label={i18n.sprintf(
        i18n.gettext('Your %s purchase summary'),
        type === 'event' ? i18n.gettext('ticket') : i18n.gettext('coupon')
      )}
    >
      {image ? <Image aria-hidden="true" rel="preload" src={image} /> : null}
      <InnerContainer>
        <Heading>
          <Name $bigHeader={step === CONFIRMATION}>{`${
            step === CONFIRMATION ? formValues.get('num') + ' x ' : ''
          }${name}`}</Name>
          <div>
            {eventDate} {i18n.gettext('at')} {eventTime}
          </div>
        </Heading>
        {step !== CONFIRMATION ? <Divider /> : null}
        <PurchaseInfo $hideOnSmallScreen={step === CONFIRMATION}>
          <Amount>
            {formValues.get('num')} x{' '}
            {type === 'event' ? i18n.gettext('Ticket') : i18n.gettext('Coupon')}
          </Amount>
          <Price>
            {!isFree ? (
              <span>
                {localeFormattedPrice(formValues.get('num') * price, {
                  languageCode: facility.languageCode,
                  currencyCode: currency,
                })}
              </span>
            ) : (
              i18n.gettext('Free of charge!')
            )}
          </Price>
        </PurchaseInfo>
        {refNum ? (
          <TicketCode
            aria-label={`${
              type === 'event'
                ? i18n.gettext('Event code:')
                : i18n.gettext('Coupon code:')
            } ${refNum.split('').join(' ')}`}
          >
            <span aria-hidden="true">
              {type === 'event'
                ? i18n.gettext('Event code:')
                : i18n.gettext('Coupon code:')}{' '}
              {refNum}
            </span>
          </TicketCode>
        ) : null}
      </InnerContainer>
    </Container>
  );
});

export default DetailsContainer;
